import { LevelTableElement } from './level-table-element';

export const SCORE_RANGE: Readonly<LevelTableElement[]> = [
  {
    evaluation: 'HIGH',
    range: '75 - 100',
  },
  {
    evaluation: 'ABOVE-AVERAGE',
    range: '55 - 75',
  },
  {
    evaluation: 'AVERAGE',
    range: '35 - 55',
  },
  {
    evaluation: 'BELOW-AVERAGE',
    range: '15 - 35',
  },
  {
    evaluation: 'LOW',
    range: '1 - 15',
  },
];
